import Joi from '@hapi/joi'

export const LentLabourReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    divisionID: Joi.number().invalid(0).required().label("Collection Point").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),
    fromDate: Joi.string().invalid("").required().label("Search Date").messages({
        "any.required": `Date required`
    }),
    toDate: Joi.string().invalid("").required().label("Search Date").messages({
        "any.required": `Date required`
    })
}